<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.serial_num">
  <div>
    <div class="banner center" style="max-width:1000px;">
      <div class="row freeze_height">
        <div class="col-6">
          <button class="btn btn-primary" title="{{localService.languageContent.serial_num.bulk_option}}"
            (click)="onAction(1)">{{localService.languageContent.serial_num.bulk_option}}</button>
        </div>
        <div class="col-6">
          <div class="icon_action_header">
            <ngx-select style="float: left;width: 80px;margin-right: 10px; margin-top: -5px;"
              [optionValueField]="'key'" [optionTextField]="'value'" [items]="pagingCounts"
              [(ngModel)]="selectedPageCount" [noAutoComplete]="true" (select)="onLoad()" title="{{localService.languageContent.paging.row_count_in_page}}">
            </ngx-select>
            <button class="button_icon button_icon_color" style="top: -5px;" (click)="onAddOrEdit()">note_add</button>
            <button class="button_icon button_icon_color" style="top: -5px;" (click)="onPrint()">print</button>
          </div>
        </div>
      </div>
      <div class="row row_header freeze_col freeze_height">
        <div class="col-md-8">
          <div class="row">
            <div class="col-5">
              {{localService.languageContent.serial_num.status}}
            </div>
            <div class="col-7">
              {{localService.languageContent.serial_num.serial_num}}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-6">
              {{localService.languageContent.serial_num.exp_date}}
            </div>
            <div class="col-6">
              {{localService.languageContent.serial_num.bill_num}}
            </div>
          </div>
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="source">
        <div class="row styled_row freeze_col" *ngFor="let item of source.items">
          <div class="col-md-8">
            <div class="row">
              <div class="col-5">
                <i class="material-icons icon_adjust" style="float:left;"
                  (click)="onGenerateBarCode(item.key,item.v2)">qr_code_scanner</i>
                <i class="material-icons icon_adjust" style="float:left;" *ngIf="item.v3 != '2'"
                  (click)="onAddOrEdit(item.key)">edit</i>
                <span *ngIf="item.v3 == '2'" class="non_edit_serial">&nbsp;</span>
                <div class="serial_status" [ngClass]="'serial_status_'+item.v3">{{getSerialNumberStatus(item.v3)}}</div>
              </div>
              <div class="col-7 en">
                {{item.v2}}
              </div>
            </div>
          </div>
          <div class="col-md-4 en">
            <div class="row">
              <div class="col-6">
                <span>{{item.v4 == '' ? '' : (item.v4 | localDate : 'date')}}</span>
              </div>
              <div class="col-6">
                <span *ngIf="item.v5 != ''" class="button" (click)="onAction(2,item.v6)">{{item.v5}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-paging *ngIf="source" [paging]="source.paging" [IsSimple]="true" (onPagingRefreshed)="onLoad()"></app-paging>
  </div>
</div>